import React from 'react';

function Tile({ children, onClick, className, onContextMenu }) {
  return (
    <div
      onClick={onClick}
      onContextMenu={onContextMenu}
      className={`border border-olive-200 rounded-xl shadow-sm transition duration-300 ease-in-out ${onClick ? 'hover:shadow-md hover:border-olive-300' : ''
        } ${className}`}
    >
      {children}
    </div>
  );
}

export default Tile;